import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

export default function FloatingWhatsapp() {
  const { settings } = useSettings();
  const waNumber = (settings.whatsapp_number || '').replace(/\D/g, '');
  const msg = encodeURIComponent('Hola Gifts GT, me gustaría consultar sobre un producto 💖');

  return (
    <a
      href={`https://wa.me/${waNumber}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      className="fixed bottom-6 right-6 z-30 h-14 w-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center shadow-xl hover:scale-110 transition-transform animate-float-slow"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle className="h-7 w-7" strokeWidth={2} />
      <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-30" />
    </a>
  );
}
